export default {"src":"/_next/static/media/icon_custom_prize.c4af70d3.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};